import type { User } from "firebase/auth";
import { getCurrentViewerRaceAccessState, invalidateCurrentViewerRaceAccess } from "./testRaceAccessService";
import { raceClock } from "./raceClock";
export const loadPurchasesService = async () => {
  const { purchasesService } = await import("./purchasesService");
  return purchasesService;
};

export const appSessionService = {
  getClaims: (user: User, forceRefresh?: boolean) => user.getIdTokenResult(forceRefresh),
  getRaceAccess: getCurrentViewerRaceAccessState,
  invalidateRaceAccess: invalidateCurrentViewerRaceAccess,
  loadPurchasesService,
  raceClock,
};
